// #### Recipes ####
export const SomeoneRecipe = {
    $type$: 'Recipe',
    name: 'Someone',
    crdtConfig: new Map(),
    rule: [
        {
            itemprop: 'someoneId',
            isId: true
        },
        {
            itemprop: 'mainProfile',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Profile']) }
        },
        {
            itemprop: 'identities',
            itemtype: {
                type: 'map',
                key: {
                    type: 'referenceToId',
                    allowedTypes: new Set(['Person'])
                },
                value: {
                    type: 'set',
                    item: { type: 'referenceToId', allowedTypes: new Set(['Profile']) }
                }
            }
        }
    ]
};
// #### Reverse maps ####
export const SomeoneReverseMaps = [
    ['Someone', new Set(['*'])]
];
export default [SomeoneRecipe];
//# sourceMappingURL=Someone.js.map